import * as React from 'react';

import FieldSearch from '@/components/shared/form/FieldSearch';
import { useSidebarNewsStore } from '@/stores/local/sidebar/SidebarNewsStore';
import { useDevices } from '@/utils/devices';

import s from './NewsSearch.module.scss';

const NewsSearch: React.FC = () => {
  const { isCompactViewport } = useDevices();
  const { searchField, fetchNews } = useSidebarNewsStore();

  const blurInput = React.useCallback(
    (target?: HTMLElement | null) => {
      if (!isCompactViewport) {
        return;
      }

      const element = target ?? (document.activeElement instanceof HTMLElement ? document.activeElement : null);

      if (!element) {
        return;
      }

      window.setTimeout(() => {
        element.blur();
      }, 0);
    },
    [isCompactViewport],
  );

  const handleKeyDown = React.useCallback(
    (e: React.KeyboardEvent<HTMLInputElement>) => {
      if (e.key === 'Enter' || e.key === 'Go') {
        e.preventDefault();
        fetchNews({ reset: true });
        blurInput(e.currentTarget);
      }
    },
    [blurInput, fetchNews],
  );

  const handleReset = React.useCallback(() => {
    searchField.reset();
    fetchNews({ reset: true });
  }, [fetchNews, searchField]);

  const handleSearch = React.useCallback(() => {
    fetchNews();
    blurInput();
  }, [blurInput, fetchNews]);

  return (
    <FieldSearch
      onKeyDown={handleKeyDown}
      placeholder={isCompactViewport ? 'Поиск' : 'Что Вас интересует?'}
      size="md"
      store={searchField}
      onClear={handleReset}
      onSearch={handleSearch}
      className={s.root}
      inputClassName={s.root__input}
    />
  );
};

export default React.memo(NewsSearch);
